import { Button } from 'components/Button/Button';
import { DatePicker } from 'components/Date/DatePicker';
import { Label } from 'components/Label/Label';
import { VerticalSpacer } from 'components/VerticalSpacer/VerticalSpacer';
import { useI18n } from 'i18n/hooks/useI18n';
import { SearchDateRangeAccordionItem } from 'modules/search/components/DateRange/AccordionItem/SearchDateRangeAccordionItem';
import { SearchDateRangeDropdown } from 'modules/search/components/DateRange/Dropdown/SearchDateRangeDropdown';
import { SEARCH_COMMON_REFINEMENT_LABELS } from 'modules/search/constants/refinements/searchCommonRefinementTypes';
import { useSearchDateRangeReset } from 'modules/search/hooks/dateRange/useSearchDateRangeReset';
import { useSearchDateRange } from 'modules/search/hooks/facets/useSearchDateRange';
import type { SearchRefinementVariant } from 'modules/search/types/SearchRefinementVariant';
import { spacing } from 'theme/theme';

type Props = {
  variant?: SearchRefinementVariant;
};

export function ActionDateRange({ variant = 'dropdown' }: Props) {
  const { i18n } = useI18n();

  const { startsLT, endsGT, onChangeStart, onChangeEnd } =
    useSearchDateRange('actionDate');

  const resetFacet = useSearchDateRangeReset('actionDate');

  const DateRangeVariant =
    variant === 'accordion'
      ? SearchDateRangeAccordionItem
      : SearchDateRangeDropdown;

  return (
    <DateRangeVariant
      facetType="actionDate"
      icon="calendar"
      label={SEARCH_COMMON_REFINEMENT_LABELS.actionDate}
    >
      <Label data-qa-id="endsGT-label">{i18n('Start Date')}</Label>
      <DatePicker
        value={endsGT}
        onChange={onChangeStart}
        placeholder={i18n('Select')}
        name="endsGT"
        disablePastDates
        isTimeZoneAware
      />
      <VerticalSpacer desktop={spacing[16]} mobile={spacing[16]} />
      <Label data-qa-id="startsLT-label">{i18n('End Date')}</Label>
      <DatePicker
        value={startsLT}
        onChange={onChangeEnd}
        placeholder={i18n('Select')}
        name="startsLT"
        disablePastDates
        isTimeZoneAware
      />
      <VerticalSpacer mobile={spacing[24]} desktop={spacing[24]} />
      <Button variant="secondary" type="button" onClick={resetFacet}>
        {i18n('Reset')}
      </Button>
    </DateRangeVariant>
  );
}
